// Covalent radii (Angstrom) - Cordero et al.
// Ported from system0 and VESTA visualizer

export const elementRadii: Record<string, number> = {
  H: 0.31, He: 0.28,
  Li: 1.28, Be: 0.96, B: 0.84, C: 0.76, N: 0.71, O: 0.66, F: 0.57, Ne: 0.58,
  Na: 1.66, Mg: 1.41, Al: 1.21, Si: 1.11, P: 1.07, S: 1.05, Cl: 1.02, Ar: 1.06,
  K: 2.03, Ca: 1.76, Sc: 1.70, Ti: 1.60, V: 1.53, Cr: 1.39, Mn: 1.39,
  Fe: 1.32, Co: 1.26, Ni: 1.24, Cu: 1.32, Zn: 1.22,
  Ga: 1.22, Ge: 1.20, As: 1.19, Se: 1.20, Br: 1.20, Kr: 1.16,
  Rb: 2.20, Sr: 1.95, Y: 1.90, Zr: 1.75, Nb: 1.64, Mo: 1.54,
  Tc: 1.47, Ru: 1.46, Rh: 1.42, Pd: 1.39, Ag: 1.45, Cd: 1.44,
  In: 1.42, Sn: 1.39, Sb: 1.39, Te: 1.38, I: 1.39, Xe: 1.40,
  Cs: 2.44, Ba: 2.15, La: 2.07, Ce: 2.04, Pr: 2.03, Nd: 2.01,
  Pm: 1.99, Sm: 1.98, Eu: 1.98, Gd: 1.96, Tb: 1.94, Dy: 1.92,
  Ho: 1.92, Er: 1.89, Tm: 1.90, Yb: 1.87, Lu: 1.87,
  Hf: 1.75, Ta: 1.70, W: 1.62, Re: 1.51, Os: 1.44, Ir: 1.41,
  Pt: 1.36, Au: 1.36, Hg: 1.32,
  Tl: 1.45, Pb: 1.46, Bi: 1.48, Po: 1.40, At: 1.50, Rn: 1.50,
  Fr: 2.60, Ra: 2.21, Ac: 2.15, Th: 2.06, Pa: 2.00, U: 1.96,
  Np: 1.90, Pu: 1.87, Am: 1.80, Cm: 1.69, Bk: 1.60, Cf: 1.60,
  Es: 1.60, Fm: 1.60, Md: 1.60, No: 1.60, Lr: 1.60,
  Rf: 1.60, Db: 1.60, Sg: 1.60, Bh: 1.60, Hs: 1.60, Mt: 1.60,
  Ds: 1.60, Rg: 1.60, Cn: 1.60, Nh: 1.60, Fl: 1.60, Mc: 1.60,
  Lv: 1.60, Ts: 1.60, Og: 1.60,
};

// Pauling electronegativity values
// Used for Schomaker-Stevenson bond length correction
export const electronegativity: Record<string, number> = {
  H: 2.20, He: 0,
  Li: 0.98, Be: 1.57, B: 2.04, C: 2.55, N: 3.04, O: 3.44, F: 3.98, Ne: 0,
  Na: 0.93, Mg: 1.31, Al: 1.61, Si: 1.90, P: 2.19, S: 2.58, Cl: 3.16, Ar: 0,
  K: 0.82, Ca: 1.00, Sc: 1.36, Ti: 1.54, V: 1.63, Cr: 1.66, Mn: 1.55,
  Fe: 1.83, Co: 1.88, Ni: 1.91, Cu: 1.90, Zn: 1.65,
  Ga: 1.81, Ge: 2.01, As: 2.18, Se: 2.55, Br: 2.96, Kr: 3.00,
  Rb: 0.82, Sr: 0.95, Y: 1.22, Zr: 1.33, Nb: 1.60, Mo: 2.16,
  Tc: 1.90, Ru: 2.20, Rh: 2.28, Pd: 2.20, Ag: 1.93, Cd: 1.69,
  In: 1.78, Sn: 1.96, Sb: 2.05, Te: 2.10, I: 2.66, Xe: 2.60,
  Cs: 0.79, Ba: 0.89, La: 1.10, Ce: 1.12, Pr: 1.13, Nd: 1.14,
  Pm: 1.13, Sm: 1.17, Eu: 1.20, Gd: 1.20, Tb: 1.10, Dy: 1.22,
  Ho: 1.23, Er: 1.24, Tm: 1.25, Yb: 1.10, Lu: 1.27,
  Hf: 1.30, Ta: 1.50, W: 2.36, Re: 1.90, Os: 2.20, Ir: 2.20,
  Pt: 2.28, Au: 2.54, Hg: 2.00,
  Tl: 1.62, Pb: 2.33, Bi: 2.02, Po: 2.00, At: 2.20, Rn: 2.20,
  Fr: 0.70, Ra: 0.90, Ac: 1.10, Th: 1.30, Pa: 1.50, U: 1.38,
  Np: 1.36, Pu: 1.28, Am: 1.30, Cm: 1.30, Bk: 1.30, Cf: 1.30,
  Es: 1.30, Fm: 1.30, Md: 1.30, No: 1.30, Lr: 1.30,
};

export function getElementRadius(element: string): number {
  return elementRadii[element] || 1.5;
}

export function getElectronegativity(element: string): number {
  return electronegativity[element] ?? 1.5;
}
